var _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5996 18.04C26.4076 18.008 26.2076 18 25.9996 18H17.9996C17.7756 18 17.5596 18.016 17.3516 18.048C17.4636 17.824 17.6236 17.616 17.8156 17.424L20.4156 14.816C21.5116 13.728 23.2876 13.728 24.3836 14.816L25.7836 16.232C26.2956 16.736 26.5676 17.376 26.5996 18.04Z",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.3999H27.6C26.72 22.3999 26 23.1199 26 23.9999C26 24.8799 26.72 25.5999 27.6 25.5999H30",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C14 19.824 15.312 18.304 17.352 18.048C17.56 18.016 17.776 18 18 18H26C26.208 18 26.408 18.008 26.6 18.04C28.664 18.28 30 19.808 30 22V26C30 28.4 28.4 30 26 30H18C15.6 30 14 28.4 14 26V25.208",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.9901550c6e3e201a337726e46c5b466a.svg";
export { ForwardRef as ReactComponent };